export const getShopCartNum = state => state.shopCartNum
export const getCurrentAddress = state => state.currentAddress
export const getEditAddress = state => state.editAddress
export const getCategoryList = state => state.categoryList
export const getSlideBarShowFlag = state => state.slideBarShowFlag
export const getSwiperIndex = state => state.swiperIndex
export const getGoodsDetail = state => state.goodsDetail
export const getGoodsComment = state => state.goodsComment
export const getTypeId = state => state.typeId
export const getIsIpx = state => state.isIpx
export const getHotelCode = state => state.hotelCode
export const getIsOpenShare = state => state.isOpenShare
export const getKeepAlive = state => state.keepAlive
export const getShopcartNum = state => state.shopcartNum




// WEBPACK FOOTER //
// ./src/store/getters.js